module.exports = __webpack_public_path__ + "img/wx.8dacbb34.svg";